<template>
  <div v-if="videoId">
    <k-modal class="video-preview-modal" :show="showModal" @close="$emit('close');">
      <template #header>
        <h3>Preview</h3>
      </template>
      <template #body>
        <media-video
          v-if="videoPreviewSource"
          :video-src="videoPreviewSource"
          :video-id="videoId"
          aria-label="Preview video player"
          :transcript-source="transcriptSource"
          :has-transcript="hasTranscript"
        />
      </template>
    </k-modal>
  </div>
</template>

<style scoped>
.video-preview-modal .modal-container {
  max-height: 90vh;
}

.video-preview-modal .video-js {
  max-height: 65vh;
}

.preview-status {
  margin: 0;
}
</style>

<script>
import KModal from '@base-components/k-modal.vue';
import MediaVideo from '@base-components/media/video.vue';

export default {
  components: {
    'k-modal': KModal,
    MediaVideo,
  },

  props: {
    videoId: {
      type: Number,
    },
    hasTranscript: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showModal: false,
      videoPreviewSource: undefined,
    };
  },

  watch: {
    videoId(val) {
      if (val) {
        this.previewVideo();
      } else {
        this.showModal = false;
        this.videoPreviewSource = undefined;
      }
    },
  },

  computed: {
    transcriptSource() {
      return `/api/static/video/${this.videoId}/transcript`;
    },
  },

  methods: {
    previewVideo() {
      this.$logger.info('Getting video source with signed URL', { videoId: this.videoId }, true);
      this.$Loading.minimal();
      this.$http.get(`/api/curriculum/admin/video/${this.videoId}/watch`)
        .then(result => {
          this.$logger.info('Got signed URL', { videoId: this.videoId });
          this.videoPreviewSource = result.data.src;
          this.showModal = true;
        }).catch(err => {
          this.$logger.error('Error getting signed URL', { videoId: this.videoId }, err);
          this.$ktoast.showError(err);
        }).then(() => {
          this.$Loading.finish();
        });
    },
  },
};
</script>
